import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {StoreService} from './store.service';

@Injectable({
    providedIn: 'root',
})
export class QueryService<StateType> {
    private readonly store: StoreService<StateType>;

    // eslint-disable-next-line @angular-eslint/prefer-inject
    public constructor(@Inject(StoreService<StateType>) store: StoreService<StateType>) {
        this.store = store;
    }

    public select<K extends keyof StateType>(key: K): Observable<StateType[K]>;
    public select<R>(selections: (store: StateType) => R): Observable<R>;
    public select(): Observable<StateType>;
    public select<R>(selections?: ((store: StateType) => R) | keyof StateType): Observable<R | StateType> {
        let mapFn;
        if (typeof selections === 'string') {
            mapFn = (state: StateType): unknown => state[selections];
        } else if (typeof selections === 'function') {
            mapFn = selections;
        } else {
            mapFn = (state: StateType): unknown => state;
        }
        return this.store.select(mapFn as (store: StateType) => R);
    }

    public getValue(): StateType {
        return this.store.getValue();
    }
}
